<template>
  <div class="p-grid">
    <div class="p-col-12">
      <InputText v-model="model.name"></InputText>
      <InputNumber v-model="model.age"></InputNumber>
      <Checkbox v-model="model.confirm" binary></Checkbox>
    </div>
    <div class="p-col-12">
      <Button @click="onSubmit" label="submit"></Button>
      <Button @click="onSave" label="save"></Button>
      <Button @click="onReset" label="reset"></Button>
    </div>
    <div class="p-col-12">
      <Message v-for="message in v$.model.$errors" :key="message.$uid">{{
        message.$message
      }}</Message>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, ref, reactive } from "vue";
import { useVuelidate } from "@vuelidate/core";
import { requiredIf, helpers } from "@vuelidate/validators";

export default defineComponent({
  name: "Test",
  setup() {
    const model = reactive({
      name: "",
      age: 1,
      confirm: false,
    });
    const submit = ref(false);
    const customRule = (value: any) => {
      return value != null && submit.value != true;
    };
    const rules = computed(() => ({
      model: {
        name: {
          // required: requiredIf(() => submit.value == true),
          required: helpers.withMessage("ERROR", customRule),
        },
      },
    }));

    const v$ = useVuelidate(rules, { model });
    const onSubmit = () => {
      submit.value = true;
      v$.value.$reset();
      v$.value.$touch();
    };
    const onSave = () => {
      submit.value = false;
      v$.value.$reset();
      v$.value.$touch();
    };
    const onReset = () => {
      v$.value.$reset();
    };
    return {
      v$,
      model,
      onSubmit,
      onSave,
      onReset,
      submit,
    };
  },
});
</script>

<style></style>
